// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.upload-page-container {
  /* margin: 100px;; */
}

.upload-file-container {
  /* padding: 50px; */
  background-color: rgb(255, 255, 255);
  color: rgb(33, 43, 54);
  transition: box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  background-image: none;
  overflow: hidden;
  position: relative;
  box-shadow: rgb(145 158 171 / 20%) 0px 0px 2px 0px,
    rgb(145 158 171 / 12%) 0px 12px 24px -4px;
  border-radius: 16px;
}

.upload-file-title > h1 {
  font-size: 25px;
  font-weight: 700;
}

.upload-file-title {
  margin-bottom: 50px;
}

.drag-and-drop-div {
  display: flex;
  outline: none;
  cursor: pointer;
  overflow: hidden;
  position: relative;
  /* padding: 40px; */
  border-radius: 8px;
  transition: padding 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  background-color: rgb(244, 246, 248);
  border: 1px dashed rgba(145, 158, 171, 0.32);
}
.upload-logo-img {
  width: 225px;
  margin-left: 20%;
}
.drag-drop-placeholder-text {
  margin: auto 30px;
}
.drag-drop-placeholder-text > h3 {
  display: block;
}
.drag-and-drop-submit-btn-div {
  display: flex;
  flex-direction: row-reverse;
  margin: 0 0 30px;
}

.drag-and-drop-submit-btn-div > button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  position: relative;
  box-sizing: border-box;
  -webkit-tap-highlight-color: transparent;
  outline: 0px;
  border: 0px;
  margin: 0px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  vertical-align: middle;
  appearance: none;
  text-decoration: none;
  font-weight: 700;
  line-height: 1.71429;
  text-transform: capitalize;
  font-family: "Public Sans", sans-serif;
  min-width: 64px;
  padding: 4px 10px;
  border-radius: 8px;
  transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
    box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
    border-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
    color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  color: rgb(255, 255, 255);
  background-color: rgb(0, 171, 85);
  box-shadow: none;
  height: 45px;
  width: 130px;
  font-size: 15px;
}
.all-uploaded-files {
  margin: 20px 0;
}
.uploaded-file {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 8px;
  margin-bottom: 8px;
  padding: 6px 8px;
  border-radius: 6px;
  border: 1px solid rgba(145, 158, 171, 0.24);
}
.uploaded-file > ul {
  margin-bottom: 0;
  width: 100%;
}
.uploaded-file > ul > li {
  width: 100%;
  /* border: 1px solid red; */
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  display: flex;
}
.file-name-title {
  margin: 0px;
  font-weight: 600;
  line-height: 1.57143;
  font-size: 0.875rem;
  font-family: "Public Sans", sans-serif;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.file-size-title {
  margin: 0px;
  line-height: 1.5;
  font-size: 0.75rem;
  font-family: "Public Sans", sans-serif;
  font-weight: 400;
  color: rgb(99, 115, 129);
}

.upload-file-navbar {
  background: #ffffff !important;
  box-shadow: none !important;
  border: 1px solid #e2e2e2 !important;
}
.user-name-container {
  margin: 10px;
  margin-bottom: 50px;
}

.user-name-container > h1 {
  font-size: 20px;
  font-weight: 700;
}
.logOutBtnScreen {
  font-family: "Montserrat" !important;
  font-size: 16px !important;
  font-weight: 700 !important;
  line-height: 26px !important;
  letter-spacing: 0px !important;
  text-align: center !important;
  width: 94px !important;
  height: 34px !important;
  padding: 6px, 16px, 6px, 16px !important;
  border-radius: 8px !important;
  background-color: #00ab55 !important;
  color: #ffffff !important;
  text-transform: capitalize !important;
  margin-right: 133px !important;
}
.dashBoard{
  font-family: "Montserrat" !important;
  font-size: 16px !important;
  font-weight: 700 !important;
  line-height: 26px !important;
  letter-spacing: 0px !important;
  text-align: center !important;
  width: 94px !important;
  height: 34px !important;
  padding: 6px, 16px, 6px, 16px !important;
  background-color: transparent !important;
  color: black !important;
  text-transform: capitalize !important;
  margin-right: 133px !important;
}
.logOutBtn {
  font-family: "Montserrat" !important;
  font-size: 16px !important;
  font-weight: 700 !important;
  line-height: 26px !important;
  letter-spacing: 0px !important;
  text-align: left !important;
  width: 172px !important;
  height: 48px !important;
  padding: 11px, 55px, 11px, 56px !important;
  border-radius: 8px !important;
  background-color: #00ab55 !important;
  color: #ffffff !important;
}
`, "",{"version":3,"sources":["webpack://./src/pages/uploadFile/uploadFile.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,oCAAoC;EACpC,sBAAsB;EACtB,6DAA6D;EAC7D,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB;6CAC2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,0DAA0D;EAC1D,oCAAoC;EACpC,4CAA4C;AAC9C;AACA;EACE,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,sBAAsB;EACtB,wCAAwC;EACxC,YAAY;EACZ,WAAW;EACX,WAAW;EACX,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;EAChB,oBAAoB;EACpB,0BAA0B;EAC1B,sCAAsC;EACtC,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB;;;gDAG8C;EAC9C,yBAAyB;EACzB,iCAAiC;EACjC,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,2CAA2C;AAC7C;AACA;EACE,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,WAAW;EACX,2BAA2B;EAC3B,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,sCAAsC;EACtC,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,sCAAsC;EACtC,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,oCAAoC;AACtC;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,oCAAoC;EACpC,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;EAC5B,8BAA8B;EAC9B,6BAA6B;EAC7B,sBAAsB;EACtB,uBAAuB;EACvB,wCAAwC;EACxC,6BAA6B;EAC7B,oCAAoC;EACpC,yBAAyB;EACzB,qCAAqC;EACrC,8BAA8B;AAChC;AACA;EACE,oCAAoC;EACpC,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;EAC5B,8BAA8B;EAC9B,6BAA6B;EAC7B,sBAAsB;EACtB,uBAAuB;EACvB,wCAAwC;EACxC,wCAAwC;EACxC,uBAAuB;EACvB,qCAAqC;EACrC,8BAA8B;AAChC;AACA;EACE,oCAAoC;EACpC,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;EAC5B,8BAA8B;EAC9B,2BAA2B;EAC3B,uBAAuB;EACvB,uBAAuB;EACvB,0CAA0C;EAC1C,6BAA6B;EAC7B,oCAAoC;EACpC,yBAAyB;AAC3B","sourcesContent":[".upload-page-container {\n  /* margin: 100px;; */\n}\n\n.upload-file-container {\n  /* padding: 50px; */\n  background-color: rgb(255, 255, 255);\n  color: rgb(33, 43, 54);\n  transition: box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n  background-image: none;\n  overflow: hidden;\n  position: relative;\n  box-shadow: rgb(145 158 171 / 20%) 0px 0px 2px 0px,\n    rgb(145 158 171 / 12%) 0px 12px 24px -4px;\n  border-radius: 16px;\n}\n\n.upload-file-title > h1 {\n  font-size: 25px;\n  font-weight: 700;\n}\n\n.upload-file-title {\n  margin-bottom: 50px;\n}\n\n.drag-and-drop-div {\n  display: flex;\n  outline: none;\n  cursor: pointer;\n  overflow: hidden;\n  position: relative;\n  /* padding: 40px; */\n  border-radius: 8px;\n  transition: padding 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n  background-color: rgb(244, 246, 248);\n  border: 1px dashed rgba(145, 158, 171, 0.32);\n}\n.upload-logo-img {\n  width: 225px;\n  margin-left: 20%;\n}\n.drag-drop-placeholder-text {\n  margin: auto 30px;\n}\n.drag-drop-placeholder-text > h3 {\n  display: block;\n}\n.drag-and-drop-submit-btn-div {\n  display: flex;\n  flex-direction: row-reverse;\n  margin: 0 0 30px;\n}\n\n.drag-and-drop-submit-btn-div > button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  box-sizing: border-box;\n  -webkit-tap-highlight-color: transparent;\n  outline: 0px;\n  border: 0px;\n  margin: 0px;\n  cursor: pointer;\n  user-select: none;\n  vertical-align: middle;\n  appearance: none;\n  text-decoration: none;\n  font-weight: 700;\n  line-height: 1.71429;\n  text-transform: capitalize;\n  font-family: \"Public Sans\", sans-serif;\n  min-width: 64px;\n  padding: 4px 10px;\n  border-radius: 8px;\n  transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,\n    box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,\n    border-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,\n    color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n  color: rgb(255, 255, 255);\n  background-color: rgb(0, 171, 85);\n  box-shadow: none;\n  height: 45px;\n  width: 130px;\n  font-size: 15px;\n}\n.all-uploaded-files {\n  margin: 20px 0;\n}\n.uploaded-file {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  margin-top: 8px;\n  margin-bottom: 8px;\n  padding: 6px 8px;\n  border-radius: 6px;\n  border: 1px solid rgba(145, 158, 171, 0.24);\n}\n.uploaded-file > ul {\n  margin-bottom: 0;\n  width: 100%;\n}\n.uploaded-file > ul > li {\n  width: 100%;\n  /* border: 1px solid red; */\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  display: flex;\n}\n.file-name-title {\n  margin: 0px;\n  font-weight: 600;\n  line-height: 1.57143;\n  font-size: 0.875rem;\n  font-family: \"Public Sans\", sans-serif;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.file-size-title {\n  margin: 0px;\n  line-height: 1.5;\n  font-size: 0.75rem;\n  font-family: \"Public Sans\", sans-serif;\n  font-weight: 400;\n  color: rgb(99, 115, 129);\n}\n\n.upload-file-navbar {\n  background: #ffffff !important;\n  box-shadow: none !important;\n  border: 1px solid #e2e2e2 !important;\n}\n.user-name-container {\n  margin: 10px;\n  margin-bottom: 50px;\n}\n\n.user-name-container > h1 {\n  font-size: 20px;\n  font-weight: 700;\n}\n.logOutBtnScreen {\n  font-family: \"Montserrat\" !important;\n  font-size: 16px !important;\n  font-weight: 700 !important;\n  line-height: 26px !important;\n  letter-spacing: 0px !important;\n  text-align: center !important;\n  width: 94px !important;\n  height: 34px !important;\n  padding: 6px, 16px, 6px, 16px !important;\n  border-radius: 8px !important;\n  background-color: #00ab55 !important;\n  color: #ffffff !important;\n  text-transform: capitalize !important;\n  margin-right: 133px !important;\n}\n.dashBoard{\n  font-family: \"Montserrat\" !important;\n  font-size: 16px !important;\n  font-weight: 700 !important;\n  line-height: 26px !important;\n  letter-spacing: 0px !important;\n  text-align: center !important;\n  width: 94px !important;\n  height: 34px !important;\n  padding: 6px, 16px, 6px, 16px !important;\n  background-color: transparent !important;\n  color: black !important;\n  text-transform: capitalize !important;\n  margin-right: 133px !important;\n}\n.logOutBtn {\n  font-family: \"Montserrat\" !important;\n  font-size: 16px !important;\n  font-weight: 700 !important;\n  line-height: 26px !important;\n  letter-spacing: 0px !important;\n  text-align: left !important;\n  width: 172px !important;\n  height: 48px !important;\n  padding: 11px, 55px, 11px, 56px !important;\n  border-radius: 8px !important;\n  background-color: #00ab55 !important;\n  color: #ffffff !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
